import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Divider, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { EditModalContent, EditModalHandlers } from './edit-givebox-modal-content';

interface EditModalProps {
	bonus: Bonus;
	isOpen: boolean;
	onDelete: VoidFunction;
	onClose: VoidFunction;
	onRequestClose: VoidFunction;
}

export const EditModal: FC<EditModalProps> = ({ bonus, isOpen, onDelete, onClose, onRequestClose }) => {
	const { t } = useTranslation('recognition');

	// We need access to the state of the editor, whether it has been changed or not, so
	// we can show a confirmation modal if the user tries to close the editor without
	// saving their changes.
	const modalRef = useRef<EditModalHandlers>(null);

	return (
		<>
			<Modal isOpen={isOpen} onClose={() => modalRef.current?.requestClose()} scrollBehavior="inside" size="2xl">
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>{t('edit_bonus.header')}</ModalHeader>
					<ModalCloseButton borderRadius="full" />
					<Divider />

					<EditModalContent
						bonus={bonus}
						onClose={onClose} // called to directly close the modal
						onDelete={onDelete}
						onRequestClose={onRequestClose} // called to trigger the confirmation modal if the editor has been changed
						onSuccess={onClose}
						ref={modalRef}
					/>
				</ModalContent>
			</Modal>
		</>
	);
};
